export const Alert = {
	// Alert related Api calls

	followOrganisation(params) {
		return this.service.post(
			'/api/alert/follow',
			params,
			response => Promise.resolve(response)
		)
	},

	loadJobAlert(params) {
		return this.service.post(
			'/api/alert/'+params.job_alert_id,
			params,
			response => Promise.resolve(response)
		)
	},

	createJobAlert(params) {
		return this.service.post(
			'/api/alert/create',
			params,
			response => Promise.resolve(response)
		)
	},

	updateJobAlert(params) {
		return this.service.post(
			'/api/alert/'+params.job_alert_id+'/update',
			params,
			response => Promise.resolve(response)
		)
	},

	deleteJobAlert(params) {
		return this.service.post(
			'/api/alert/'+params.job_alert_id+'/delete',
			params,
			response => Promise.resolve(response)
		)
	},

	toggleJobAlertNotifications(params) {
		return this.service.post(
			'/api/alert/'+params.job_alert_id+'/notifications',
			params,
			response => Promise.resolve(response)
		)
	},
}
